import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHashtag = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.83317 14.6667L4.61442 10.5M4.61442 10.5L5.55192 5.50004M4.61442 10.5H10.4478M4.61442 10.5H0.916504M5.55192 5.50004L6.33317 1.33337M5.55192 5.50004L11.3853 5.50004M5.55192 5.50004H1.74984M9.6665 14.6667L10.4478 10.5M10.4478 10.5L11.3853 5.50004M10.4478 10.5H14.2498M11.3853 5.50004L12.1665 1.33337M11.3853 5.50004H15.0832",
		stroke: "#71717A",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgHashtag);
export default ForwardRef;
